import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import KioskRedirectModal from "./modals/KioskRedirectModal";
import GradientButton from "./gradients/GradientButton";
import { useSearchParams } from "react-router-dom";
import { Box, Container, Stack } from "@mui/material";

const useStyles = makeStyles({
  logoContainer: {
    width: "fit-content",
    position: "absolute",
    zIndex: 2,
    cursor: "pointer",
    margin: "1rem 0",
    top: "0",
    left: "10px",
  },
  logoImage: {
    width: "75px",
    height: "auto",
    marginBottom: "8px",
  },
  buttonContainer: {
    width: "fit-content",
    position: "absolute",
    zIndex: 2,
    cursor: "pointer",
    margin: "1rem 0",
    top: "0",
    right: "0",
  },
});

const HeaderKioskComponent = ({ data, isMobile, orderPreviewMode }) => {
  const { isKiosk, customer, setLoading } = data;

  if (!isKiosk) return null;

  const classes = useStyles();
  const [searchParams] = useSearchParams();

  const [modalValue, setValue] = useState({ open: false, type: "logo" }); // type: logo || design

  const urlStringId = searchParams.get("orderPreviewUid");

  const isSavedDesigns = Boolean(Object.keys(customer?.savedDesigns ?? {}).length);

  const handleOpen = React.useCallback(
    (value = "logo") => {
      setValue((prevState) => ({ open: !prevState.open, type: value }));
    },
    [modalValue]
  );

  const goBackPreview = React.useCallback(() => {
    if (!urlStringId) return;
    setLoading(true);

    window.location.assign(`https://${process.env.REACT_APP_CALLBACK_URL}/cart?c=${urlStringId}`);
  }, [urlStringId]);

  const logoAction = orderPreviewMode ? goBackPreview : () => handleOpen("logo");

  return (
    <>
      <Container className={classes.logoContainer}>
        <GradientButton onClick={logoAction}>
          <Stack direction="row" alignItems="center" gap={1}>
            Go to Homepage
            <Box>
              <img
                src="//cdn.shopify.com/s/files/1/0563/2737/2823/files/supermix-logo.png?14859"
                alt="Supermix Logo"
                className={classes.logoImage}
              />
            </Box>
          </Stack>
        </GradientButton>
      </Container>
      {orderPreviewMode && (
        <Container className={classes.buttonContainer}>
          <GradientButton
            addStyle={{ minHeight: "45px", fontSize: "15px" }}
            onClick={goBackPreview}
          >
            Go Back
          </GradientButton>
        </Container>
      )}
      {customer && isSavedDesigns && !orderPreviewMode && (
        <Container className={classes.buttonContainer}>
          <GradientButton
            addStyle={{ minHeight: "45px", fontSize: "15px" }}
            onClick={() => handleOpen("design")}
          >
            Saved Designs
          </GradientButton>
        </Container>
      )}
      <KioskRedirectModal
        modalValue={modalValue}
        isUser={customer}
        isMobile={isMobile}
        handleClose={handleOpen}
      />
    </>
  );
};

export default HeaderKioskComponent;
